import type { ListBuilderList } from '../../../types';
import { createLowStockMerchandiserColumns } from '../columns';
import { MERCHANDISER_REQUIRED_FIELDS } from '../shared';

/**
 * Low Stock Merchandisers list configuration
 * Shows merchandiser locations with low stock (below 25% capacity)
 */
export const lowStockMerchandisersList: ListBuilderList = {
	id: 'low-stock-merchandisers',
	cacheTTL: 600000,
	name: 'Low Stock Merchandisers',
	type: 'default',
	active: true,
	columns: createLowStockMerchandiserColumns(),
	description: 'Merchandiser locations with low stock (below 25% capacity)',
	defaultSortId: 'column-location-code-asc',
	filterRules: {
		locationType: {
			defaultValue: [{ id: 'merchandiser', label: 'Merchandiser' }],
		},
		stockLevel: {
			defaultValue: [
				{ id: 'empty', label: 'Empty' },
				{ id: 'low', label: 'Low' },
			],
		},
	},
	requiredFields: [...MERCHANDISER_REQUIRED_FIELDS, 'location.units'],
	sortOrder: 4,
};
